import React, { Component } from 'react';
import { base  } from '../../base';
import '../../styles/css/Scoreboard.css';
import { Profanity, ProfanityOptions } from '@2toad/profanity';
import {Textfit} from "react-textfit";

const options = new ProfanityOptions();
options.wholeWord = false;
options.grawlix = '*****';
options.grawlixChar = '$';

const profanity = new Profanity(options);
profanity.whitelist.addWords(["sassy", "hello", "shelly"])
profanity.addWords(['ahole','anus','ash0le','ash0les','asholes','ass','assmonkey','assface','assh0le','assh0lez','asshole','asshole','assholes','assholz','asswipe','azzhole','bassterds','bastard','bastards','bastardz','basterds','basterdz','biatch','bitch','bitches','blowjob','boffing','butthole','buttwipe','c0ck','c0cks','c0k','carpetmuncher','cawk','cawks','clit','cnts','cntz','cock','cockhead','cockhead','cocks','cocksucker','cocksucker','crap','cum','cunt','cunts','cuntz','dick','dild0','dild0s','dildo','dildos','dilld0','dilld0s','dominatricks','dominatrics','dominatrix','dyke','enema','fag','fag1t','faget','fagg1t','faggit','faggot','fagit','fags','fagz','faig','faigs','fart','fuck','fucker','fuckin','fucking','fucks','fudgepacker','fuk','fukah','fuken','fuker','fukin','fukk','fukkah','fukken','fukker','fukkin','g00k','gay','gaybor','gayboy','gaygirl','gays','gayz','goddamned','h00r','h0ar','h0re','hells','hell','hoar','hoor','hoore','jackoff','jap','japs','jerkoff','jisim','jiss','jizm','jizz','knob','knobs','knobz','kunt','kunts','kuntz','lesbian','lezzian','lipshits','lipshitz','masochist','masokist','massterbait','masstrbait','masstrbate','masterbaiter','masterbate','masterbates','mutha','fuker','motha','fucker','fuker','fukka','fukkah','fucka','fuchah','fukker','fukah','mothafucker','mothafuker','mothafukkah','mothafukker','motherfucker','motherfukah','motherfuker','motherfukkah','motherfukker','motherfucker','muthafucker','muthafukah','muthafuker','muthafukkah','muthafukker','mutha','n1gr','nastt','nasty','nigger','nigur','niiger','niigr','orafis','orgasim','orgasm','orgasum','oriface','orifice','orifiss','packi','packie','packy','paki','pakie','paky','pecker','peeenus','peeenusss','peenus','peinus','pen1s','penas','penis','penisbreath','penus','penuus','phuc','phuck','phuk','phuker','phukker','polac','polack','polak','poonani','pr1c','pr1ck','pr1k','pusse','pussee','pussy','puuke','puuker','queer','queers','queerz','qweers','qweerz','qweir','recktum','rectum','retard','sadist','scank','schlong','screwing','semen','sex','sexx','sexxx','sx','sexy','sht','sh1t','sh1ter','sh1ts','sh1tter','sh1tz','shit','shits','shitter','shitty','shity','shitz','shyt','shyte','shytty','shyt','skanck','skank','skankee','skankey','skanks','skanky','slut','sluts','slutty','slutz','sonofabitch','tit','turd','va1jina','vag1na','vagiina','vagina','vaj1na','vajina','vullva','vulva','w0p','wh00r','wh0re','whore','xrated','xxx','bch','bitch','blowjob','clit','arschloch','fuck','shit','ass','asshole','btch','b17ch','b1tch','bastard','bich','boiolas','buceta','c0ck','cawk','chink','cipa','clits','cock','cum','cunt','dildo','dirsa','ejakulate','fatass','fcuk','fuk','fux0r','hoer','hore','jism','kawk','l3itch','l3i+ch','lesbian','masturbate','masterbat','masterbat3','motherfucker','s.o.b.','mofo','nazi','nigga','nigger','nutsack','phuck','pimpis','pusse','pussy','scrotum','shemale','shi+','shitt','slut','smut','teets','tits','boobs','b00bs','teez','testical','testicle','titt','w00se','jackoff','wank','whoar','whore','damn','dyke','fuck','shit','@$$','amcik','andskota','arse','assrammer','ayir','bi7ch','bitch','bollock','breasts','buttpirate','cabron','cazzo','chraa','chuj','cock','cunt','d4mn','daygo','dego','dick','dike','dupa','dziwka','ejackulate','ekrem','ekto','enculer','faen','fag','fanculo','fanny','feces','feg','felcher','ficken','fitt','flikker','foreskin','fotze','fuk','futkretzn','gay','gook','guiena','h0r','h4x0r','helvete','hoer','honkey','huevon','hui','injun','jizz','kanker','kike','klootzak','kraut','knulle','kuk','kuksuger','kurac','kurwa','kusi','kyrpa','lesbo','mamhoon','masturbat','merd','mibun','monkleigh','mouliewop','muie','mulkku','muschi','nazis','nepesaurio','nigger','orospu','paska','perse','picka','pierdol','pillu','pimmel','piss','pizda','poontsee','poop','porn','p0rn','pr0n','preteen','pula','pule','puta','puto','qahbeh','queef','rautenberg',"schaffer","scheiss","schlampe","schmuck","screw","sharmuta","sharmute","shipal","shiz","skrib"]);

class Leaderboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tenantVariables: {},
            topTenMovers: []
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount(){
        document.title = "Leaderboard";
        this.scoreboardSettingsRef = base.listenTo(`scoreboardSettings`, {
            context: this,
            then(variables){
                this.setState({
                    otherBlockedNames: variables.otherBlockedNames
                })
            }
        });
        this.userAnswersRef = base.listenTo(`scoreboardData`, {
            context: this,
            queries: {
                orderByChild: 'numberOfMoves',
                limitToFirst: 10
            },
            then(topTenMovers){
                this.getEmailsAndCreateLeaderBoard(topTenMovers);
            }
        });
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    async getEmailsAndCreateLeaderBoard(topTenMovers){
        const topTenMoversArray= [];
        for(const i in topTenMovers){
            let firstName = topTenMovers[i].firstName;
            firstName = this.checkIfFirstNameInOtherBlockedNames(firstName);
            topTenMovers[i]['name'] = firstName + " " + topTenMovers[i].lastName;
            topTenMovers[i]['name'] = this.profanityCheck(topTenMovers[i]['name']);
            topTenMoversArray.push(topTenMovers[i]);
        }
        topTenMoversArray.sort((a,b) => a.numberOfMoves - b.numberOfMoves);
        this.setState({
            topTenMovers: topTenMoversArray,
            loading: false
        })
    }

    checkIfFirstNameInOtherBlockedNames(name){
        if(!name) return name;
        const otherBlockedNames = this.state.otherBlockedNames || "";
        const lowerCaseBlockedNames = otherBlockedNames.toLowerCase();
        if(lowerCaseBlockedNames.indexOf(name.toLowerCase()) !== -1){
            name = "*****"
        }
        return name;
    }

    profanityCheck(name){
        return profanity.censor(name);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillUnmount() {
        base.removeBinding(this.userAnswersRef);
        base.removeBinding(this.scoreboardSettingsRef);
    }

    checkIfSmallestFontSize(fontSizeToCheck){
        if(!fontSizeToCheck) return;
        if(!this.state.smallestFont || fontSizeToCheck < this.state.smallestFont){
            this.setState({smallestFont: fontSizeToCheck})
        }
    }

    render() {
        const tenantVariables = this.props.variables || {};
        const smallestFont = this.state.smallestFont;
        const topTenMovers = this.state.topTenMovers || [];
        const backgroundImage = tenantVariables.scoreboardBackgroundImage;
        const bottomImage = tenantVariables.scoreboardFooterImage;
        const qrCodeScoreboardImage = tenantVariables.qrCodeScoreboardImage;
        const scoreboardImage = tenantVariables.scoreboardImage;
        const scoreboardBackgroundFontColor = tenantVariables.scoreboardBackgroundFontColor || "black";
        const scoreboardFontColor = tenantVariables.scoreboardFontColor || "white";
        const scoreboardRankTextColor = tenantVariables.scoreboardRankTextColor || "black";
        if(this.state.loading){
            return (
                <div className="loading-screen"/>
            )
        }
        return (
            <div className="container-fluid" style={{backgroundImage: "url(" + backgroundImage + ")", height: "100vh"}}>
                <div className="row" style={{height:"80%"}}>
                    {qrCodeScoreboardImage &&
                        <div className="col-3 d-none d-md-block" style={{marginTop: "4%", textAlign: "center", marginLeft: !scoreboardImage ? "auto": ""}}>
                            <p className="scan-to-play-text" style={{color:scoreboardRankTextColor}}>SCAN TO PLAY</p>
                            <img src={qrCodeScoreboardImage} alt="" style={{maxWidth: "100%", maxHeight: "100%"}}/>
                        </div>
                    }
                    {scoreboardImage &&
                        <div className="col" style={{marginTop: "4%", textAlign: "center"}}>
                            <img src={scoreboardImage} alt="" style={{maxWidth: "100%", maxHeight: "100%"}}/>
                        </div>
                    }
                    <div id="leaderboard-section" className="col-12 col-md-5" style={{marginTop: "4%", marginRight: !scoreboardImage? "auto" : "", marginLeft: !scoreboardImage ? "auto":"", paddingRight: "2%"}}>
                        <div className="container">
                            <div className="row">
                              <div className="col-7 offset-1">
                                  <div style={{width:"100%"}}>
                                      <span className="column-title" style={{color: scoreboardFontColor, backgroundColor: scoreboardBackgroundFontColor}}>NAME</span>
                                  </div>
                              </div>
                              <div className="col-3 text-center text-md-left" style={{margin: "auto"}}>
                                  <span className="column-title" style={{color: scoreboardFontColor, backgroundColor: scoreboardBackgroundFontColor}}>MOVES</span>
                              </div>
                            </div>
                            <div style={{height:"1vw", width:"100%"}}/>
                            {topTenMovers.map(function (item, index) {
                                return <div className="row column-item" key={index} style={{color: scoreboardRankTextColor}}>
                                    <div className="col-1" style={{marginTop:"auto", marginBottom:"auto"}}>
                                        {index+1}.
                                    </div>
                                    <div className="col-7" style={{marginTop: "auto", marginBottom: "auto"}}>
                                        {(item.name || item.uid) &&
                                            <Textfit onReady={(textSize) => this.checkIfSmallestFontSize(textSize)} forceSingleModeWidth={false} mode="single" max={64} min={20}>
                                                <div style={{textOverflow: 'ellipsis', overflow:'hidden', whiteSpace: "nowrap"}}>
                                                    <span style={{fontSize: smallestFont && smallestFont}}>{item.name || item.uid}</span>
                                                </div>
                                            </Textfit>
                                        }
                                    </div>
                                    <div className="col-3" style={{margin:"auto", textAlign:"center"}}>
                                        <Textfit forceSingleModeWidth={false} mode="single" max={64} min={20}>
                                            <span style={{fontSize: smallestFont && smallestFont}}>
                                                {item.numberOfMoves}
                                            </span>
                                        </Textfit>
                                    </div>
                                </div>
                            }, this)}
                        </div>
                    </div>
                </div>
                <div className="row" style={{height: "10%"}}>
                    <img src={bottomImage} alt="" className="bottomBarImage"/>
                </div>
            </div>
        );
    }
}

export default Leaderboard;
